import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ExposureForSegByOrgLevel } from 'src/app/models/exposureBySeg.model';
import { MatTableSortOptions } from 'src/app/models/sort.model';
import { CommonService } from 'src/app/services/common.service';

@Component({
  standalone: false,
  selector: 'app-exposure-in-location',
  templateUrl: './exposure-in-location.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./exposure-in-location.component.scss']
})
export class ExposureInLocationComponent implements OnInit {
  @Input() loadingExposureDetail: boolean = true;
  @Input() exposureDetail: ExposureForSegByOrgLevel[];
  @Input() showSegReport: boolean = true;
  sortBy: string = "id";
  orderBy: string = "asc";
  colors: any = this.commonService.colors;

  constructor(private commonService: CommonService,) { }

  ngOnInit(): void {
  }

  sort(sortBy: string) {
    if (!(this.sortBy == sortBy)) {
      this.sortBy = sortBy;
    }
    this.load(this.sortBy, this.orderBy);
  }

  sortSEG(tableSortOptions: MatTableSortOptions) {
    this.orderBy = tableSortOptions.direction;
    this.sort(tableSortOptions.active);
  }

  load(sortBy: string, orderBy: string) {
    this.exposureDetail.sort((a, b) => {
      if (a[sortBy] < b[sortBy]) {
        return orderBy === 'asc' ? -1 : 1;
      }
      if (a[sortBy] > b[sortBy]) {
        return orderBy === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  public trackByIndex = trackByIndex;
}
